/*******************************************************
 *******************************************************
 * UTILITIES FUNCTIONS
 *******************************************************
 *******************************************************/
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`
    }
  };
}

function debounce(fn, wait = 300) {
  let timeoutId;

  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), wait);
  };
}

/** Video unities functions (deferred-media, ...) */
function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

/*******************************************************
 *******************************************************
 * SCROLL LOCK
 *******************************************************
 *******************************************************/
function bodyScrollLock() {
  const keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

  function preventDefault(e) {
    e.preventDefault();
  }

  function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
      preventDefault(e);

      return false;
    }
  }

  let supportsPassive = false;
  try {
    window.addEventListener(
      'test',
      null,
      Object.defineProperty({}, 'passive', {
        get: function () {
          supportsPassive = true;
        }
      })
    );
  } catch (e) {}

  const wheelOpt = supportsPassive ? { passive: false } : false;
  const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

  function disableScroll() {
    window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
    window.addEventListener('keydown', preventDefaultForScrollKeys, false);
  }

  disableScroll();

  return () => {
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
    window.removeEventListener('touchmove', preventDefault, wheelOpt);
    window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
  };
}

/*******************************************************
 *******************************************************
 * COOKIES FUNCTIONS
 *******************************************************
 *******************************************************/
if (typeof Cookies == 'undefined') {
  var Cookies = {
    createCookie(name, value, days) {
      let expires = '';
      if (days) {
        let date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toGMTString();
      }

      document.cookie = name + '=' + value + expires + '; path=/';
    },

    readCookie(name) {
      let nameEQ = name + '=';
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }

      return null;
    },

    deleteCookie(name) {
      document.cookie = name + '; expires = Thu, 01 Jan 1970 00:00:00 GMT' + '; path=/';

      return null;
    }
  };
}

/*******************************************************
 *******************************************************
 * GENERATE CURRENCY GLOBAL OBJECT
 *******************************************************
 *******************************************************/
if (typeof localCurrency === 'undefined') {
  var localCurrency = {
    format: 'money_with_currency_format',
    money_format: {
      USD: '${{amount}}',
      ILS: '₪{{amount}}',
      EUR: '&euro;{{amount}}',
      GBP: '&pound;{{amount}}',
      CAD: '${{amount}}',
      ARS: '${{amount_with_comma_separator}}',
      AUD: '${{amount}}',
      BBD: '${{amount}}',
      BDT: 'Tk {{amount}}',
      BSD: 'BS${{amount}}',
      BHD: '{{amount}}0 BHD',
      BRL: 'R$ {{amount_with_comma_separator}}',
      BOB: 'Bs{{amount_with_comma_separator}}',
      BND: '${{amount}}',
      BGN: '{{amount}} лв',
      MMK: 'K{{amount}}',
      KYD: '${{amount}}',
      CLP: '${{amount_no_decimals}}',
      CNY: '&#165;{{amount}}',
      COP: '${{amount_with_comma_separator}}',
      CRC: '&#8353; {{amount_with_comma_separator}}',
      HRK: '{{amount_with_comma_separator}} kn',
      CZK: '{{amount_with_comma_separator}} K&#269;',
      DKK: '{{amount_with_comma_separator}}',
      DOP: 'RD$ {{amount_with_comma_separator}}',
      XCD: '${{amount}}',
      EGP: 'LE {{amount}}',
      XPF: '{{amount_no_decimals_with_space_separator}}} XPF',
      FJD: '${{amount}}',
      GHS: 'GH&#8373;{{amount}}',
      GTQ: '{{amount}}',
      GYD: '${{amount}}',
      GEL: '{{amount}} GEL',
      HKD: '${{amount}}',
      HUF: '{{amount_no_decimals_with_comma_separator}}',
      ISK: '{{amount_no_decimals}} kr',
      INR: '{{amount}}',
      IDR: '{{amount_with_comma_separator}}',
      NIS: '{{amount}} NIS',
      JMD: '${{amount}}',
      JPY: '&#165;{{amount_no_decimals}}',
      JOD: '{{amount}}0 JD',
      KZT: '{{amount}} KZT',
      KES: 'KSh{{amount}}',
      KWD: '{{amount}}0 KD',
      LVL: 'Ls {{amount}}',
      LTL: '{{amount}} Lt',
      MXN: '$ {{amount}}',
      MYR: 'RM{{amount}} MYR',
      MUR: 'Rs {{amount}}',
      MDL: '{{amount}} MDL',
      MAD: '{{amount}} dh',
      MNT: '{{amount_no_decimals}} &#8366',
      MZN: '{{amount}} Mt',
      ANG: '&fnof;{{amount}}',
      NZD: '${{amount}}',
      NGN: '&#8358;{{amount}}',
      NOK: '{{amount_with_comma_separator}} kr',
      OMR: '{{amount_with_comma_separator}} OMR',
      PKR: 'Rs.{{amount}}',
      PYG: 'Gs. {{amount_no_decimals_with_comma_separator}}',
      PEN: 'S/. {{amount}}',
      PHP: '&#8369;{{amount}}',
      PLN: '{{amount_with_comma_separator}} zl',
      QAR: 'QAR {{amount_with_comma_separator}}',
      RON: '{{amount_with_comma_separator}} lei',
      RUB: '&#1088;&#1091;&#1073;{{amount_with_comma_separator}}',
      SAR: '{{amount}} SR',
      RSD: '{{amount}} RSD',
      SCR: 'Rs {{amount}}',
      SGD: '${{amount}}',
      SYP: 'S&pound;{{amount}}',
      ZAR: 'R {{amount}}',
      KRW: '&#8361;{{amount_no_decimals}}',
      LKR: 'Rs {{amount}}',
      SEK: '{{amount_no_decimals}} kr',
      CHF: 'SFr. {{amount}}',
      TWD: '${{amount}}',
      THB: '{{amount}} &#xe3f;',
      TZS: '{{amount}} TZS',
      TTD: '${{amount}}',
      TRY: '{{amount}}TL',
      UAH: '₴{{amount}}',
      AED: 'Dhs. {{amount}}',
      UYU: '${{amount_with_comma_separator}}',
      VEB: 'Bs. {{amount_with_comma_separator}}',
      VND: '{{amount_no_decimals_with_comma_separator}}₫',
      ZMK: 'K{{amount_no_decimals_with_comma_separator}}'
    },
    money_with_currency_format: {
      USD: '${{amount}} USD',
      ILS: '₪{{amount}} ILS',
      EUR: '&euro;{{amount}} EUR',
      GBP: '&pound;{{amount}} GBP',
      CAD: '${{amount}} CAD',
      ARS: '${{amount_with_comma_separator}} ARS',
      AUD: '{{amount}} AUD',
      BBD: '${{amount}} Bds',
      BDT: 'Tk {{amount}} BDT',
      BSD: 'BS${{amount}} BSD',
      BHD: '{{amount}}0 BHD',
      BRL: 'R$ {{amount_with_comma_separator}} BRL',
      BOB: 'Bs{{amount_with_comma_separator}} BOB',
      BND: '${{amount}} BND',
      BGN: '{{amount}} лв BGN',
      MMK: 'K{{amount}} MMK',
      KYD: '${{amount}} KYD',
      CLP: '${{amount_no_decimals}} CLP',
      CNY: '&#165;{{amount}} CNY',
      COP: '${{amount_with_comma_separator}} COP',
      CRC: '&#8353; {{amount_with_comma_separator}} CRC',
      HRK: '{{amount_with_comma_separator}} kn HRK',
      CZK: '{{amount_with_comma_separator}} K&#269;',
      DKK: 'kr.{{amount_with_comma_separator}}',
      DOP: 'RD$ {{amount_with_comma_separator}}',
      XCD: 'EC${{amount}}',
      EGP: 'LE {{amount}} EGP',
      XPF: '{{amount_no_decimals_with_space_separator}}} XPF',
      FJD: 'FJ${{amount}}',
      GHS: 'GH&#8373;{{amount}}',
      GTQ: '{{amount}} GTQ',
      GYD: '${{amount}} GYD',
      GEL: '{{amount}} GEL',
      HKD: 'HK${{amount}}',
      HUF: '{{amount_no_decimals_with_comma_separator}} Ft',
      ISK: '{{amount_no_decimals}} kr ISK',
      INR: 'Rs.{{amount}}',
      IDR: 'Rp {{amount_with_comma_separator}}',
      NIS: '{{amount}} NIS',
      JMD: '${{amount}} JMD',
      JPY: '&#165;{{amount_no_decimals}} JPY',
      JOD: '{{amount}}0 JOD',
      KZT: '{{amount}} KZT',
      KES: 'KSh{{amount}}',
      KWD: '{{amount}}0 KWD',
      LVL: 'Ls {{amount}} LVL',
      LTL: '{{amount}} Lt',
      MXN: '$ {{amount}} MXN',
      MYR: 'RM{{amount}} MYR',
      MUR: 'Rs {{amount}} MUR',
      MDL: '{{amount}} MDL',
      MAD: 'Dh {{amount}} MAD',
      MNT: '{{amount_no_decimals}} MNT',
      MZN: 'Mt {{amount}} MZN',
      ANG: '{{amount}} NA&fnof;',
      NZD: '${{amount}} NZD',
      NGN: '&#8358;{{amount}} NGN',
      NOK: 'kr {{amount_with_comma_separator}} NOK',
      OMR: '{{amount_with_comma_separator}} OMR',
      PKR: 'Rs.{{amount}} PKR',
      PYG: 'Gs. {{amount_no_decimals_with_comma_separator}} PYG',
      PEN: 'S/. {{amount}} PEN',
      PHP: '&#8369;{{amount}} PHP',
      PLN: '{{amount_with_comma_separator}} zl PLN',
      QAR: 'QAR {{amount_with_comma_separator}}',
      RON: '{{amount_with_comma_separator}} lei RON',
      RUB: '&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB',
      SAR: '{{amount}} SAR',
      RSD: '{{amount}} RSD',
      SCR: 'Rs {{amount}} SCR',
      SGD: '${{amount}} SGD',
      SYP: 'S&pound;{{amount}} SYP',
      ZAR: 'R {{amount}} ZAR',
      KRW: '&#8361;{{amount_no_decimals}} KRW',
      LKR: 'Rs {{amount}} LKR',
      SEK: '{{amount_no_decimals}} kr SEK',
      CHF: 'SFr. {{amount}} CHF',
      TWD: '${{amount}} TWD',
      THB: '{{amount}} &#xe3f; THB',
      TZS: '{{amount}} TZS',
      TTD: '${{amount}} TTD',
      TRY: '{{amount}}TL',
      UAH: '₴{{amount}} UAH',
      AED: 'Dhs. {{amount}} AED',
      UYU: '${{amount_with_comma_separator}} UYU',
      VEB: 'Bs. {{amount_with_comma_separator}} VEB',
      VND: '{{amount_no_decimals_with_comma_separator}} VND',
      ZMK: 'ZMK{{amount_no_decimals_with_comma_separator}}'
    },
    currentCurrency: window.shopCurrency.shop,
    cookie: {
      expires: 365,
      name: 'badno_currency',
      write(value) {
        Cookies.createCookie(this.name, value, this.expires);
      },
      read() {
        return Cookies.readCookie(this.name);
      },
      destroy() {
        Cookies.createCookie(this.name, null, this.expires);
      }
    },
    formatMoney(cents, format = '') {
      var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString =
          format || this.money_format[this.currentCurrency] || '{{amount_no_decimals}}';

      if (typeof cents == 'string') {
        cents = cents.replace('.', '');
      }

      function defaultOption(opt, def) {
        return typeof opt == 'undefined' ? def : opt;
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents = parts[1] ? decimal + parts[1] : '';

        return dollars + cents;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0, ' ', '.');
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', '.');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', '.');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    },
    convertAll(prevCountryCode, countryCode, shopFormat, additionalSelector) {
      let moneyElements = additionalSelector || document.querySelectorAll('.money');

      moneyElements.forEach((element) => {
        const dataCurrency = element.dataset.currency;
        if (!dataCurrency) return;

        let prevFormatMoney = this[shopFormat || this.format][prevCountryCode] || '{{amount}}',
          format = this[shopFormat || this.format][countryCode] || '{{amount}}',
          priceText = element.innerHTML.replace(/[^0-9]/g, ''),
          cents = 0;

        if (prevFormatMoney.indexOf('amount_no_decimals') !== -1) {
          cents = Currency.convert(parseInt(priceText, 10) * 100, prevCountryCode, countryCode);
        } else {
          if (prevCountryCode === 'JOD' || prevCountryCode == 'KWD' || prevCountryCode == 'BHD') {
            cents = Currency.convert(parseInt(priceText, 10) / 10, prevCountryCode, countryCode);
          } else {
            cents = Currency.convert(parseInt(priceText, 10), prevCountryCode, countryCode);
          }
        }

        const formatedMoney = this.formatMoney(cents, format);
        element.innerHTML = formatedMoney;
      });

      this.currentCurrency = countryCode;
      this.cookie.write(countryCode);
    },
    formatPrice(price) {
      let formatPrice = price.toString();

      const currencyFormat = shopCurrency.moneyFormat || '{{amount_no_decimals}} kr';
      formatPrice = this.formatMoney(formatPrice, currencyFormat);

      return formatPrice;
    }
  };
}

/*******************************************************
 *******************************************************
 * GENERATE SHOPIFY OBJECTS
 *******************************************************
 *******************************************************/
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;

      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};
